import { Box } from "@mui/material";
import { ReactNode, useEffect } from "react";
import { COLOR } from "../../utils/colors";
import ConfigSidebar from "./_components/sidebar";
import { useSharedIsExpanded } from "./_functions";
import { VIEW } from "../../utils/breakpoint";
import { useEnableConfigPage } from "../../hooks/config-page";

export default function ConfigLayout({ children }: { children: ReactNode }) {
  const { isExpanded, setIsExpanded } = useSharedIsExpanded();

  const enableConfigPage = useEnableConfigPage();

  useEffect(() => {
    if (!enableConfigPage) {
      window.location.href = '/';
    }
  }, []);

  return (
    <>
      {enableConfigPage && (
        <Box sx={{ display: 'flex', maxHeight: '100vh', width: '100vw', overflow: 'hidden' }}>
          <ConfigSidebar />
          <Box
            onClick={() => setIsExpanded(false)}
            sx={(theme) => ({
              zIndex: 20,
              position: 'absolute',
              inset: '0',
              backgroundColor: 'black',
              display: isExpanded ? 'inline-block' : 'none',
              opacity: isExpanded ? 0.5 : 0,
              [theme.breakpoints.up(VIEW.TABLET)]: {
                display: 'none'
              }
            })} />
          <Box sx={{ flexGrow: 1, height: '100vh', overflowY: 'auto', backgroundColor: COLOR.background.screen }}>
            {children}
          </Box>
        </Box>
      )}
    </>
  )
}